import { css } from '@emotion/core'
import styled, { Theme } from '@themes/theme'

export const DateSpan = styled.p`
  color: ${props => props.theme.color.modalSubTxt};
`
export const ListItemTitle = styled.div`
  color: ${props => props.theme.color.modalTxt};
  display: inline-block;
  width: 100%;
  margin: 0 0 4px;
  font-size: ${props => props.theme.font.large};
`
export const ListItemWrap = (theme: Theme) => css`
  line-height: 1.4rem;
  font-size: ${theme.font.small};
  &:nth-of-type(2)::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 90%;
    height: 25px;
    border-right: ${theme.border.line};
  }
`
export const DummyStyle = css`
  display: block;
  margin: 0 auto;
  width: 25px;
`
export const SellerName = styled.span`
  display: block;
  color: ${props => props.theme.color.modalTxt};
  font-size: ${props => props.theme.font.small};
`
export const Txt = styled.span`
  display: block;
  color: ${props => props.theme.color.modalSubTxt};
  font-size: ${props => props.theme.font.small};
`
export const Num = styled.span`
  width: 100%;
  display: inline-block;
  color: ${props => props.theme.color.modalTxt};
  &.pick-popup {
    /* float: right; */
    width: 92%;
    text-align: right;
  }
`
export const Money = styled.span`
  width:calc(100% - 16px);
  display: inline-block;
  text-align: right;
  color: ${props => props.theme.color.modalTxt};
`
export const GmoneyStyle = styled.span`
  position: relative;
  float: right;
  width: 12px;
  svg {
    position: absolute;
    right: 0;
    width: 12px;
    transform: translateY(8%);
  }
  &.modal {
    svg {
      transform: translateY(-8%);
    }
  }
`
export const PopupTxt = styled.p`
  color: ${props => props.theme.color.modalSubTxt};
  font-size: ${props => props.theme.font.large};
  margin-top: 2px;
  span {
    float: none;
    width: auto;
    svg {
      position: relative;
      top: 2px;
      margin: 0 2px;
    }
  }
`
export const ModalBodyWarp = styled.div`
  .am-list .am-list-item.am-list-item-middle {
    height: auto;
    max-height: 98px;
    padding: 10px 14px;
    line-height: 1.7rem;
    border: ${props => props.theme.border.line};
    background: ${props => props.theme.color.contentsBg};
    transition: all 0.3s;
    .am-list-line {
      padding: 0;
      overflow: visible;
      border: none; /* pc버전에서 픽 공유 리스트에 라인 생기는 현상 해결 */
      &::after {
        display: none;
      }
      .am-list-content {
        padding: 0;
      }
    }
  }
  .list-item-selector {
    background: ${props => props.theme.color.subBg} !important;
    border: 1px solid red;
  }
`
// 픽 공유
export const MessageListWrap = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding: 5px 11px 10px 11px;
  text-align: left;
  border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
`
// 베팅 내역 공유
export const BettingShareWrap = styled.div`

`

export const SharedBetStyle = (theme:Theme) => css`
  position: relative;
  margin-bottom: 14px;
  border-radius: 12px;
  .top-info {
    .message-bet-btn {
      position: absolute;
      top: 7px;
      right: 11px;
      width: auto;
      height: 30px;
      padding: 9px;
      color: ${theme.color.modalyellow};
      background: none;
      border-radius: 0;
      &.release {
        .x-ico {
          position: relative;
          width: 13px;
          height: 13px;
          transform: rotate(45deg);
          &::before, &::after {
            content:'';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: ${theme.color.modalgray};
          }
          &::before {
            width: 1px;
            height: 13px;
          }
          &::after {
            width: 13px;
            height: 1px;
          }
        }
      }
      &.save {
        text-decoration: underline;
      }
    }
    .my-bet-info {
      margin: 9px 0;
    }
    .fold-money-list {
      border-radius: 10px;
    }
  }

  &.received {
    box-shadow: 1px 2px 9px rgba(22, 26, 35, .15);
    margin-top: 28px; // 메시지함 내 ant-collapse-header 사이의 간격을 위해 추가한 코드입니다.
  }

`
export const BettingListSelectorWrap = styled.div`
   text-align: left;
   height: 100%;
   //overflow: auto; // 리스트뷰에서 스크롤이 리스트뷰 + 전체모달창 스크롤이 중복 동작하여 제거.
  .betting-history-wrap {
    .list-view-section-body {
      width: 100%;
      padding-bottom: 60px;
    }
  //height: auto; // full-modal 일때 height:auto 이면 데이터가 보이지 않음.
    .am-list {
    //height: 100%; // 불필요하여 제거.
    }
  }
`
export const CommonBtnStyle = css`
  z-index: 2;
  position: absolute;
  right: 0;
  width: 74px !important;
  height: 28px;
  line-height: 2.8rem;
  border-radius: 50px;
`
export const MessageInputWrap = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  height: 431px;
  .ant-form  {
    flex: 1;
    display: flex;
    flex-flow: column;
    padding: 0 10px;
    .ant-row.ant-form-item, .ant-form-item-with-help {
      margin-bottom: 7px;
      .ant-form-item-control {
        &.has-error {
          .ant-form-explain {
            top: -8%;
            padding-left: 0;
          }
        }
        &.has-success {
          .ant-form-explain {
            color: ${props => props.theme.color.secondaryBg};
            top: -8%;
            padding-left: 0;
          }
        }
      }
    }
    .receive-club {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 33px;
      color: ${props => props.theme.color.modalgray};
      font-size: ${props => props.theme.font.medium};
      border-bottom: 1px solid ${props => props.theme.color.modalSubBg2};
      .nickname {
        margin-left: 6px;
        color: ${props => props.theme.color.modalTxt};
      }
    }
    .nick-input {
      height: 46px;
      line-height: 100%;
      .ant-input-wrapper {
        height: inherit;
        border-bottom: 1px solid ${props => props.theme.color.modalBg};
        .ant-input {
          height: inherit;
          padding: 0;
          border: none;
          border-radius: 0;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.medium};
          font-weight: ${props => props.theme.fontW.medium};
          &::placeholder {
            color: #acacac !important;
          }
          &:hover, &:focus, &:active {
            border: none !important;
          }
        }
        .ant-input-group-addon {
          width: 60px;
          height: 34px;
          padding: 6px 0;
          background: none;
          .ant-btn {
            height: 100%;
            padding: 0 14px;
            background: ${props => props.theme.color.modalBg};
            border: none;
            box-shadow: none;
            text-shadow: none;
            border-radius: 50px;
            &::after {
              display:none;
            }
            span {
              color: ${props => props.theme.color.modalTxt};
              font-size: ${props => props.theme.font.small};
              font-weight: ${props => props.theme.fontW.medium};
            }
          }
        }
      }
    }
    .message-contents-box {
      position: relative;
      display: flex;
      flex-flow: column;
      flex-wrap: wrap;
      height: 100%;
      margin-bottom: 21px;
      padding: 10px 0;
      border-bottom: 1px solid ${props => props.theme.color.modalBg};
      .ant-row.ant-form-item {
        flex: 1;
        width: calc(100% - 36px);
        margin-bottom: 6px;
        .ant-form-item-control-wrapper, .ant-form-item-control, .ant-form-item-children {
          height: 100%;
        }
        .text-input {
          height: 100%;
          padding: 0;
          border: none;
          resize: none;
          border-radius: 0;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.medium};
          font-weight: ${props => props.theme.fontW.medium};
          &::placeholder {
            color: #acacac !important;
          }
          &:active, &:hover, &:focus {
            border: none !important;
          }
        }
      }
      .shared.link.url {
        flex: initial;
        width: 100%;
        padding-top: 18px;
        margin: 0;
        .ant-form-explain {
          top: -14px;
        }
      }
      .attached-btn {
        position: absolute;
        top: 0;
        right: 0;
        display:flex;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        background: none;
        svg {
          width: 20px;
          height: auto;
        }
      }
    }
  }

  .loading-btn {
    & > div {
      height: auto;
    }
  }
`
// const ErrorTxt = styled.p`
//   display: block;
//   font-size: ${props => props.theme.font.small};
//   color: ${props => props.theme.color.red};
// `
export const ImageWrap = styled.div`
  display:block;
  width: 102px;
  height: 102px;
  min-height: 102px;
  border-radius: 12px;
  margin-bottom: 30px;
  overflow: hidden;
  .img-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 0;
    background: ${props => props.theme.color.modalSubBg};
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .zoom-ico {
      display: block;
      position: absolute;
      bottom: 6px;
      right: 6px;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: ${props => props.theme.color.whiteBg};
      box-shadow: 0 2px 4px #00000014;
      .magnifying-glass-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 11px;
        height: auto;
      }
    }
  }
  &.system-message {
    width: 100%;
    height: 102px;
    max-height: 102px;
    margin-bottom: 6px;
    text-align: left;
    line-height: 1.4rem;
    .img-wrapper {
      position: relative;
      width: 100%;
      height: 102px;
      max-height: 102px;
      overflow: hidden;
      border-radius: 0;
      img {
        width: 100%;
        height: auto;
      }
      .zoom-ico {
        bottom: 10px;
        right: 10px;
        width: 30px;
        height: 30px;
        .magnifying-glass-icon {
          width: 13px;
        }
      }
    }
  }
`
export const LinkWrap = styled.div`
  display:block;
  height: auto;
  max-height: 50px;
  text-align: left;
  line-height: 1.4rem;
  .attached-link {
    display: block;
    max-height: 50px;
    overflow: scroll;
    color: ${props => props.theme.color.secondaryBg};
    text-decoration: underline;
    word-break: break-all;
  }
  &.message-popup {
    margin-bottom: 10px;
  }
`
export const UploadMessageImgStyle = css`
  width: auto;
  height: auto;
  overflow: scroll;
  img {
    width: 100%;
    height: auto;
  }
`
export const ModalTxt = styled.div`
  display: block;
  margin-top: 2px;
  margin-bottom: 10px;
  text-align: right;
  font-size: ${props => props.theme.font.small};
  color: ${props => props.theme.color.modalSubTxt};
`
// const SendBtnStyle = css`
//   position: relative;
//   left: -14px;
//   width: calc(100% + 28px);
//   height: 36px;
//   border-radius: 0;
// `
export const PickBtnStyle = (theme: Theme) => css`
  ${CommonBtnStyle};
  top: 30px;
  &.gift {
    top: 45px;
  }
`
export const ModalGmoneyStyle = styled.span`
  position: relative;
  //top: 1.4px;
  width: 10px;
  margin: 0 1px;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
`
export const ModalBottomBtnStyle = css`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  border-radius: 0;
`
export const ImgPreview = styled.div`
  position: relative;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 72px;
  padding: 9px;
  background:  ${props => props.theme.color.modalBg};
  .upload-img-preview {
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 54px;
  }
  .delete-img-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 42px;
    height: 42px;
    background: none;
    transform: rotate(45deg);
    .x-ico {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      &::before, &::after {
        content:'';
        display: block;
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2px;
        height: 18px;
        border-radius: 10px;
        background: ${props => props.theme.color.gray};
      }
      &::after {
        width: 18px;
        height: 2px;
      }
    }
  }
`
